import React from 'react'
import './Home.css'
import Banner from './Banner'
import Privacy from './Privacy'

function Home() {
    return (
        <div className='home'>
            <Banner />
            <Privacy />
        </div>
    )
}

export default Home
